import { useQuery } from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useComments = (model: string, modelUuid: string) => {
  const middleman = useMiddleman();
  return useQuery(['comments', model, modelUuid], () => {
    return middleman.promiseGet(`/crm/comments/${model}/${modelUuid}`).then(res => res.data);
  }, { enabled: !!model && !!modelUuid, refetchOnWindowFocus: false });
};
